import CalendarActionGroupIdResponse from 'owa-service/lib/contract/CalendarActionGroupIdResponse';
import createCalendarGroupOperation from 'owa-service/lib/operation/createCalendarGroupOperation';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import { MailboxInfo } from 'owa-client-ids';

/**
 * Creates a calendar group on server
 * @param {string} groupName The name of new calendar group to create
 * @returns The response with the created group's id
 */
export default function createCalendarGroupService(
    groupName: string,
    mailboxInfo: MailboxInfo
): Promise<CalendarActionGroupIdResponse> {
    return createCalendarGroupOperation(
        {
            newGroupName: groupName,
        },
        getMailboxRequestOptions(mailboxInfo)
    );
}
